import { render, staticRenderFns } from "./ItemListElement.vue?vue&type=template&id=559f4408&"
import script from "./ItemListElement.vue?vue&type=script&lang=js&"
export * from "./ItemListElement.vue?vue&type=script&lang=js&"
import style0 from "./ItemListElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports